import { render, staticRenderFns } from "./helps.vue?vue&type=template&id=8b8aac34&scoped=true&"
import script from "./helps.vue?vue&type=script&lang=js&"
export * from "./helps.vue?vue&type=script&lang=js&"
import style0 from "./helps.vue?vue&type=style&index=0&id=8b8aac34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8aac34",
  null
  
)

export default component.exports